export default __webpack_public_path__ + "static/media/5.9d23da93.jpeg";